import {
  IconButton as MuiIconButton,
  type IconButtonProps as MuiIconButtonProps,
} from '@mui/material';
import { cn } from 'cn';
import React from 'react';

export type IconButtonVariant = 'ghost' | 'surface';

export type IconButtonProps = Omit<MuiIconButtonProps, 'size'> & {
  readonly size?: 'sm' | 'md';
  readonly variant?: IconButtonVariant;
};

const variantClassNames: Record<IconButtonVariant, string> = {
  ghost:
    'text-tiga-text-lighter hover:text-tiga-text-light hover:bg-black/5 focus:outline-none',
  surface:
    'bg-white text-tiga-text-lighter shadow-sm hover:bg-tiga-surface-lightest hover:text-tiga-text-light focus:outline-none',
};

const sizeClassNames: Record<NonNullable<IconButtonProps['size']>, string> = {
  sm: 'size-7',
  md: 'size-10',
};

export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  function IconButton(
    { className, size = 'md', variant = 'ghost', ...rest },
    ref,
  ) {
    return (
      <MuiIconButton
        ref={ref}
        className={cn(
          'rounded-sm transition-colors disabled:opacity-50',
          variantClassNames[variant],
          sizeClassNames[size],
          className,
        )}
        {...rest}
      />
    );
  },
);
